import { ModalAction } from '../context/ModalContext';

let _modalDispatch: React.Dispatch<ModalAction> | null = null;

export const setModalDispatcher = (dispatch: React.Dispatch<ModalAction>) => {
  _modalDispatch = dispatch;
};

export const getModalDispatcher = () => _modalDispatch;
